module.exports = __webpack_public_path__ + "img/p1@2x.c2b43c3e.png";